import efocats_validate_core from './efocats_validate_core.js';
import EFOcats_error_info from '../efocats_error_info.js';
import EFOcats_import_lang from '../import/efocats_import_lang.js';

/**
 * ひらがなチェッククラス
 */
export default class EFOcats_validate_hiragana extends efocats_validate_core {
  /**
   * エラーチェック
   */
  validate(checkData) {
    let result = new EFOcats_error_info('success', '', '', '');

    if (!checkData.val().match(/^[ぁ-んー]+$/)) {
      result = new EFOcats_error_info('error', EFOcats_import_lang.getValue('hiraganaerror'), '', EFOcats_import_lang.getValue('hiraganaerror'));
    }

    return result;
  }
}
